import {
	fetchSettingsHistoryQuery,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';
import { compareProperty, first, has, propEq } from '@gov-nx/core/types';
import { toDate } from '@gov-nx/utils/common';

export const contactHistoryQueryKey = ['komunikacniudaje', 'historie'];

interface UseContactHistoryProps {
	isEnabled: boolean;
}

export const useContactHistory = ({ isEnabled }: UseContactHistoryProps) => {
	const { axiosInstance } = useAxiosInstance();
	const query = usePoQuery({
		queryKey: contactHistoryQueryKey,
		queryFn: async () => fetchSettingsHistoryQuery(axiosInstance),
		enabled: isEnabled,
	});

	const data = query.data?.seznam
		?.filter(propEq('zdroj', 'ROB'))
		.filter(has('hodnota'))
		.filter(has('platnostOd'))
		.map((record) => ({
			value: record.hodnota,
			type: record.typ,
			validFrom: toDate(record.platnostOd),
			validTo: record.platnostDo ? toDate(record.platnostDo) : undefined,
		}));

	const latest = (type: 'EMAIL' | 'TELEFON') =>
		first(
			data
				?.filter(propEq('type', type))
				.sort(compareProperty('validFrom', 'DESC')) ?? []
		)?.value;

	return {
		isFetching: query.isFetching,
		latestEmail: latest('EMAIL'),
		latestPhone: latest('TELEFON'),
	};
};
